import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Phone: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.84348 15.3734C5.08711 15.8621 4.18581 16.0751 3.29111 15.9765C2.3964 15.8779 1.56287 15.4738 0.930666 14.8321L0.377976 14.2909C0.135671 14.0426 0 13.7093 0 13.3622C0 13.015 0.135671 12.6817 0.377976 12.4335L2.72384 10.1086C2.96961 9.86667 3.30041 9.73112 3.645 9.73112C3.98958 9.73112 4.32038 9.86667 4.56614 10.1086C4.81399 10.3512 5.14682 10.4871 5.49344 10.4871C5.84005 10.4871 6.17288 10.3512 6.42073 10.1086L10.1053 6.4183C10.2283 6.29698 10.3259 6.1524 10.3925 5.99297C10.4591 5.83353 10.4934 5.66242 10.4934 5.48958C10.4934 5.31674 10.4591 5.14563 10.3925 4.98619C10.3259 4.82675 10.2283 4.68218 10.1053 4.56087C9.86381 4.31472 9.72846 3.98341 9.72846 3.6383C9.72846 3.29318 9.86381 2.96187 10.1053 2.71573L12.439 0.378557C12.6867 0.135879 13.0197 0 13.3662 0C13.7128 0 14.0457 0.135879 14.2935 0.378557L14.8339 0.932097C15.4746 1.56528 15.8781 2.40009 15.9765 3.29617C16.075 4.19225 15.8623 5.09494 15.3743 5.85246C12.8319 9.60513 9.59694 12.8367 5.84348 15.3734Z"
      fill="currentColor"
    />
  </svg>
);
